var map = {
	"./canales.js": "2bce",
	"./category.js": "d0c1",
	"./clientes.js": "eabb",
	"./estados.js": "a8cd",
	"./getProducts.js": "7949",
	"./locales.js": "62ed",
	"./mainUI.js": "3d28",
	"./origen.js": "9f93",
	"./perfilOrigen.js": "f054",
	"./productos.js": "bd07",
	"./prospectos.js": "d0fc",
	"./reclamaciones.js": "6121",
	"./reportes.js": "1fa2",
	"./ubigeo.js": "9e41",
	"./usuarios.js": "b5ae",
	"./utilities.js": "a035"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c653";